<template>
  <div class="register_box">
    <div class="register_centent">
      <div class="register_box_title">{{ $t("register.registeraccount") }}</div>
      <div
        class="TGA_BOX"
        style="margin-top: 50px"
        v-for="(item, index) in data"
      >
        <div class="TGA_INPUT_BOX" :class="item.active ? 'TGA_BR' : ''">
          <div class="TGA_TEXT">{{ item.title }}</div>
          <input
            autocomplete="new-password"
            :class="item.type == 'number' ? 'TGA_CODE_ACTIVE' : ''"
            v-model="item.input"
            @input="changeCount(item.input, index)"
            class="TGA_INPUT"
            :type="item.type"
          />
          <div v-if="item.type == 'number' && CodeSwitch" class="TGA_CODE">
            {{ codetext }}
          </div>
          <div
            v-if="item.type == 'number' && !CodeSwitch"
            class="TGA_CODE code_active"
            @click="getcode()"
          >
            {{ $t("register.getcode") }}
          </div>
          <div class="TGA_INIT" v-if="item.init != ''">{{ item.init }}</div>
          <div class="TGA_INPUT_INIT" v-if="item.active">
            <img src="@/img/mistake.png" alt="" />
            <span>{{ item.Text }}</span>
          </div>
        </div>
      </div>

      <div class="TGA_BTN" @click="send" :class="BTN ? 'TGA_BTN_ACTIVE' : ''">
        {{ $t("register.registertext") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      type: this.$route.query.type,
      // 获取验证码开关
      switch: true,
      // 邮箱时间
      codetime: 60,
      codestate: false,
      codetext: this.$t("register.getcode"),
      data: [
        {
          title: this.$t("register.emailsite"),
          input: "",
          Text: this.$t("register.email_error"),
          active: false,
          type: "email",
          init: this.$t("register.text"),
        },
        {
          title: this.$t("register.code"),
          input: "",
          Text: this.$t("register.codekong"),
          active: false,
          type: "number",
          init: this.$t("register.codetext"),
        },
        {
          title: this.$t("register.psd"),
          input: "",
          Text: this.$t("register.empty_psd"),
          active: false,
          type: "password",
          init: this.$t("register.psd_init"),
        },
        {
          title: this.$t("register.psd1"),
          input: "",
          Text: this.$t("register.no_psd1"),
          active: false,
          type: "password",
          init: "",
        },
      ],

      BTN: false,
      CodeSwitch: true,
    };
  },
  beforeCreate() {},
  created() {
    this.keys();
  },
  methods: {
    ...mapActions("user", ["tipMessage", "Create", "SendVfCode"]),
    keys() {
      var self = this;
      document.onkeydown = (e) => {
        if (e.keyCode === 13 && self.$route.path == "/register") {
          //回车后执行搜索方法
          this.send();
        }
        return;
      };
    },
    // 点击注册
    async send() {
      if (!this.BTN) {
        return;
      }
      var affirmpassword = this.data[3].input;
      var obj = {
        account: this.data[0].input,
        nickname: this.data[0].input,
        code: this.data[1].input,
        password: this.$md5(this.data[2].input),
        roleName: this.type == 0 ? "GAME_DEVELOPER" : "APP_DEVELOPER",
        userType: "DEVELOPER",
      };

      if (obj.password != this.$md5(affirmpassword)) {
        this.data[3].Text = this.$t("register.no_psd1");
        this.data[3].active = true;
        return;
      }

      const res = await this.Create({
        $axios: this.$axios,
        ...obj,
      });

      if (res.code == 200) {
        // 提交
        this.$router.push({
          path: "/info",
        });
      } else {
        switch (res.code) {
          case -101:
          case -100:
          case 10008:
          case -114:
            this.data[0].active = true;
            this.data[0].Text = this.$t(`code[${res.code}]`);
            break;
          case 1001:
            this.data[1].active = true;
            this.data[1].Text = this.$t(`code[${res.code}]`);
            break;
          case -103:
          case -104:
          case -113:
            this.data[2].active = true;
            this.data[2].Text = this.$t(`code[${res.code}]`);
            break;
          default:
            this.$message.error(this.$t("code.info"));
        }
      }
    },
    changeCount(text, i) {
      var myReg =
        /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,64}){1,2})$/;
      var ps =
        /^[\w\!\?\,\<\>\.\@\#\$\%\^\&\*\(\)\{\}\[\]\-\~\+\=\/\\\:\;]{8,15}$/;
      if (text == "") {
        this.data[i].active = true;
        switch (i) {
          case 0:
            this.data[i].Text = this.$t("register.emailkong");
            this.CodeSwitch = true;
            break;
          case 1:
            this.data[i].Text = this.$t("register.codekong");
            break;
          case 2:
            this.data[i].Text = this.$t("register.empty_psd");
            break;
          case 3:
            this.data[i].Text = this.$t("register.empty_psd");
            break;
        }
      } else {
        if (i == 0 && !myReg.test(text)) {
          this.data[i].Text = this.$t("register.email_error");
          this.data[i].active = true;
          this.CodeSwitch = true;
        } else if (i == 1 && text.length != 6) {
          this.data[i].Text = this.$t("register.code_error");
          this.data[i].active = true;
        } else if (i == 2 && !ps.test(text)) {
          this.data[i].Text = this.$t("register.psd_init");
          this.data[i].active = true;
          if (this.data[3].input != "") {
            this.changeCount(this.data[3].input, 3);
          }
        } else if (i == 3 && this.data[2].input != text) {
          this.data[i].Text = this.$t("register.no_psd1");
          this.data[i].active = true;
        } else if (i == 3 && !ps.test(text)) {
          this.data[i].Text = this.$t("register.psd_init");
          this.data[i].active = true;
        } else {
          if (i == 0 && this.codetime == 60) {
            this.CodeSwitch = false;
          }
          this.data[i].active = false;
          if (i == 2 && this.data[3].input != "") {
            this.changeCount(this.data[3].input, 3);
          }
        }
      }
    },
    // 获取验证码
    async getcode(text) {
      var myemail = this.data[0].input;
      var myReg =
        /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,64}){1,2})$/;
      console.log(myemail);
      if (!myReg.test(myemail)) {
        this.tipMessage({
          context: this.$t("register.email_error"),
        });
        return;
      }
      if (!this.switch) {
        return;
      }
      this.switch = false;
      var obj = {
        email: myemail,
        grantType: "REGISTER",
      };
      const res = await this.SendVfCode({
        $axios: this.$axios,
        ...obj,
      });
      console.log("resresresresres", res);
      if (res.code == 200) {
        this.codetext = this.codetime + this.$t("register.anewgetcode");
        this.codestate = true;
        this.CodeSwitch = true;
        this.codetimer();
        this.tipMessage({
          context: this.$t("register.codesuccess"),
        });
      } else {
        this.data[1].active = true;
        this.data[1].Text = this.$t(`code[-31]`);
      }
    },
    // 验证码定时器
    codetimer() {
      var self = this;
      setTimeout(function () {
        self.codetime = self.codetime - 1;
        if (self.codetime > 0) {
          self.codetext = self.codetime + self.$t("register.anewgetcode");
          self.codetimer();
        } else {
          self.codetime = 60;
          self.codetext = self.$t("register.getcode");
          self.changeCount(self.data[0].input, 0);
          self.switch = true;
        }
      }, 1000);
    },
  },
  computed: {},
  watch: {
    data: {
      handler: function (newValue, oldValue) {
        for (var i = 0; i < newValue.length; i++) {
          if (newValue[i].input == "") {
            this.BTN = false;
            return;
          }
        }
        this.BTN = true;
      },
      deep: true,
    },
  },
};
</script>
<style scoped="">
.register_box {
  width: 100%;
  height: 100%;
}
.register_centent {
  margin: 90px auto 0;
  width: 1160px;
  height: 645px;
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-sizing: border-box;
  padding-top: 65px;
}
.register_box_title {
  margin-bottom: 21px;
  color: #282828;
  font-size: 22px;
  text-align: center;
  font-weight: bold;
}
.code_active {
  color: #fff;
  background-color: #4990fa;
}
.register_box .TGA_INIT {
  position: absolute;
  top: 45px;
  left: 0;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/register.vue